import {Component, OnInit} from '@angular/core';
import {UserService} from '../../services/user.service';
import {ActivatedRoute, Router} from '@angular/router';
import {User} from '../../model/Entities/User';

@Component({
    selector: 'user-detail',
    templateUrl: './user-detail.component.html',
    styleUrls: ['./user-detail.component.scss']
})
export class UserDetailComponent implements OnInit {
    user: User = new User();

    constructor(private route: ActivatedRoute,
                private userService: UserService) {
    }

    ngOnInit(): void {
        const id = +this.route.snapshot.paramMap.get('id');

        this.loadUser(id);
    }

    private loadUser(id: Number): void {
        this.userService.get(id).subscribe((user: User) => {
            this.user = user;
        });
    }
}



// WEBPACK FOOTER //
// /app/src/UsersModule/UserDetailComponent/user-detail.component.ts